/**
 * Componente: PurchaseSummaryCards
 * 
 * Muestra 4 tarjetas con estadísticas clave del historial de compras:
 * 1. Total gastado (este mes)
 * 2. Número de compras (este mes)
 * 3. Última compra realizada
 * 4. Total de evaluaciones adquiridas
 * 
 * @param {Object} summary - Objeto con datos del resumen de compras
 * @param {boolean} loading - Estado de carga
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import StatCard from 'components/StatCard';
import { formatCurrency, formatDateShort } from 'services/purchaseService';

function PurchaseSummaryCards({ summary, loading }) {
  // Valores por defecto mientras carga
  if (loading || !summary) {
    return (
      <Grid container spacing={3} mb={3}>
        {[1, 2, 3, 4].map((i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <StatCard
              title="Cargando..."
              value="---"
              subtitle=" "
              icon="pending"
              color="info"
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  console.log('📊 Summary data:', summary);

  return (
    <Grid container spacing={3} mb={3}>
      {/* Total compras */}
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Total de Compras"
          value={summary.total_purchases || 0}
          subtitle="Compras realizadas"
          icon="shopping_cart"
          color="info"
        />
      </Grid>

      {/* Total gastado */}
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Total Invertido"
          value={formatCurrency(summary.total_amount || 0)}
          subtitle="Monto total"
          icon="payments"
          color="success"
        />
      </Grid>

      {/* Compras pendientes */}
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Pendientes"
          value={summary.by_status?.pending || 0}
          subtitle="Por aprobar"
          icon="pending"
          color="warning"
        />
      </Grid>

      {/* Compras aprobadas */}
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          title="Aprobadas"
          value={summary.by_status?.completed || 0}
          subtitle="Completadas"
          icon="check_circle"
          color="success"
        />
      </Grid>
    </Grid>
  );
}

PurchaseSummaryCards.propTypes = {
  summary: PropTypes.shape({
    total_purchases: PropTypes.number,
    total_amount: PropTypes.number,
    by_status: PropTypes.shape({
      completed: PropTypes.number,
      pending: PropTypes.number,
      failed: PropTypes.number,
      refunded: PropTypes.number,
    }),
    recent_purchases: PropTypes.number,
  }),
  loading: PropTypes.bool,
};

PurchaseSummaryCards.defaultProps = {
  summary: null,
  loading: false,
};

export default PurchaseSummaryCards;
